import styled from "styled-components";

export const StyledFormationCard = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: space-between;

  & .formation-column {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const StyledFormationRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  gap: 8px;
  margin-bottom: 2px;

  & > :last-child {
    justify-self: end;
    margin-left: 8px;
  }

  @media (max-width: 870px) {
    grid-template-columns: auto auto;

    & .label {
      display: none;
    }

    & > :last-child {
      justify-self: start;
    }
  }
`;
